import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { DisplayDataComponent } from './pages/display-data/display-data.component';
import { DxDataGridModule, DxFormModule } from 'devextreme-angular';
import { AuthService } from './shared/services';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { ClientListComponent } from './core/Master/client-list/client-list.component';
import { NodatafoundComponent } from './core/component/nodatafound/nodatafound.component';
import { RegisterFormComponent } from './shared/components/register-form/register-form.component';
import { AccessDeniedComponent } from './layouts/access-denied/access-denied.component';
// import { OrgChartComponent } from './core/component/org-chart/org-chart.component';
export const appRoutes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
    canActivate: [AuthService]
  }, {
    path: 'Forgot-Password',
    loadChildren: () =>
      import('src/app/shared/components/forgot-password/forgot-password.component')
        .then(m => m.ForgotPasswordVerifyModule)
  }, {
    path: 'Verify-Account',
    loadChildren: () =>
      import('src/app/shared/components/essaccount-verify/essaccount-verify.component')
        .then(m => m.ESSAccountVerifyModule)
  }, {
    path: 'New-Password',
    loadChildren: () =>
      import('src/app/shared/components/essnew-password/essnew-password.component')
        .then(m => m.ESSNewPasswordModule)
  },
  {
    path: 'display-data',
    component: DisplayDataComponent,
    canActivate: [AuthService]
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthService]
  }, {
    path: 'My-Approvals',
    loadChildren: () => import('src/app/core/ESS/my-approvals/my-approvals.component')
      .then(m => m.MyApprovalsModule),
    canActivate: [AuthService]
  },
  {
    path: 'session-expired',
    loadChildren: () =>
      import('src/app/shared/components/token-expired-page/token-expired-page.component')
        .then(m => m.TokenExpiredModule)
  },
  {
    path: 'My-Requests',
    loadChildren: () => import('src/app/core/ESS/my-requests/my-requests.component')
      .then(m => m.MyRequestsModule),
    canActivate: [AuthService]
  }, {
    path: 'Contract-Extension-Approvals',
    loadChildren: () => import('src/app/core/ESS/contract-extension-approvals/contract-extension-approvals.component')
      .then(m => m.ContractExtensionApprovalsModule),
    canActivate: [AuthService]
  }, {
    path: 'Offer-Appoint-HR-Letter-Request-Approvals',
    loadChildren: () => import('src/app/core/ESS/common-offer-appoint-hr-lettr-app/common-offer-appoint-hr-lettr-app.component')
      .then(m => m.CommonOfferAppointHrLettrAppModule),
    canActivate: [AuthService]
  },
  {
    path: 'Notification',
    loadChildren: () => import('src/app/core/ESS/notification/notification.component')
      .then(m => m.NotificationModule),
    canActivate: [AuthService]
  },
  {
    path: 'help',
    loadChildren: () => import('src/app/core/ESS/help-files/help-files.module')
      .then(m => m.HelpFilesModule),
    canActivate: [AuthService]
  },
  {
    path: 'Associate-Aadhaar-EKyc',
    loadChildren: () =>
      import('src/app/public/public-aadhaar-ekyc/public-aadhaar-ekyc.component').then(m => m.PublicAadhaarEkycModule)
  },
  {
    path: 'Aadhaar-Digilocker-Ekyc',
    loadComponent: () => import('../../projects/public/src/app/public-aadhaar-digilacker-ekyc/public-aadhaar-digilacker-ekyc.component').then(m => m.PublicAadhaarDigilackerEkycComponent)
  },
  {
    path: 'RequirementApprove',
    loadChildren: () => import('../../projects/public/src/app/public-requirement-approval/public-requirement-approval.component').then(m => m.PublicRequirementApprovalModule)
  },
  {
    path: 'OBQuickUpdates',
    loadChildren: () =>
      import('src/app/public/public-ob-quick-updates/public-ob-quick-updates.component').then(m => m.PublicObQuickUpdatesModule)
  },
  {
    path: 'Display-Details',
    loadChildren: () =>
      import('src/app/public/public-display-details/public-display-details.component').then(m => m.PublicDisplayDetailsModule)
  },
  // {
  //   path: 'Track-me',
  //   loadChildren: () => import('src/app/core/ESS/track-me/track-me.component')
  //     .then(m => m.TrackModule),
  //   canActivate: [AuthService]
  // },

  {
    path: 'My-Document',
    loadChildren: () => import('src/app/core/ESS/my-document/my-document.component')
      .then(m => m.MyDocumentModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'Policy-Documents',
  //   loadChildren: () => import('src/app/core/ESS/policy-document/policy-document.component')
  //     .then(m => m.PolicyDocumentModule),
  //   canActivate: [AuthService]
  // },
  {
    path: 'Reimbursement-Approvals',
    loadChildren: () => import('src/app/core/ESS/reimbursement-approvals/reimbursement-approvals.component')
      .then(m => m.ReimbursementApprovalsModule),
    canActivate: [AuthService]
  }, {
    path: 'Resignation-Approvals',
    loadChildren: () => import('src/app/core/ESS/resignation-approvals/resignation-approvals.component')
      .then(m => m.ResignationApprovalsModule),
    canActivate: [AuthService]
  },{
    path: 'Import-Excel',
    loadChildren: () => import('src/app/core/component/common-import-excel/import-excel.module')
      .then(m => m.ImportExcelModule),
    canActivate: [AuthService]
  }, {
    path: 'F&F-Approvals',
    loadChildren: () => import('src/app/core/ESS/fnf-approvals/fnf-approvals.component')
      .then(m => m.FnfApprovalsModule),
    canActivate: [AuthService]
  }, {
    path: 'Pending-PMS-Goals',
    loadChildren: () => import('src/app/core/ESS/pending-pms-goals/pending-pms-goals.component')
      .then(m => m.PendingPmsGoalsModule),
    canActivate: [AuthService]
  }, {
    path: 'PMS-Assessment-Approvals',
    loadChildren: () => import('src/app/core/ESS/pms-approvals/pms-approvals.component')
      .then(m => m.PmsApprovalsModule),
    canActivate: [AuthService]
  }, {
    path: 'Probation-Pending',
    loadChildren: () => import('src/app/core/ESS/probation-pending/probation-pending.component')
      .then(m => m.ProbationPendingModule),
    canActivate: [AuthService]
  }, {
    path: 'Offer-Approvals',
    loadChildren: () => import('src/app/core/ESS/offer-approvals/offer-approvals.component')
      .then(m => m.OfferApprovalsModule),
    canActivate: [AuthService]
  }, {
    path: 'Common-Notifications',
    loadChildren: () => import('src/app/core/ESS/common-notifications/common-notifications.component')
      .then(m => m.CommonNotificationsModule),
    canActivate: [AuthService]
  }, {
    path: 'Onboard-Initiate-Approvals',
    loadChildren: () => import('src/app/core/ESS/onboard-initiate-approvals/onboard-initiate-approvals.component')
      .then(m => m.OnboardInitiateApprovalsModule),
    canActivate: [AuthService]
  }, {
    path: 'Leave-Approvals',
    loadChildren: () => import('src/app/core/ESS/leave-approval/leave-approval.component')
      .then(m => m.LeaveApprovalModule),
    canActivate: [AuthService]
  }, {
    path: 'F&F-Event-Approvals',
    loadChildren: () => import('src/app/core/ESS/fnf-event-approvals/fnf-event-approvals-module')
      .then(m => m.FnfEventApprovalsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Face-Approvals',
    loadChildren: () => import('src/app/core/ESS/face-recognition-approval/face-recognition-approval.module')
      .then(m => m.FaceRecognitionApprovalModule),
    canActivate: [AuthService]
  },
  {
    path: 'FlexiWO-Approvals',
    loadChildren: () => import('src/app/core/ESS/flexi-wo-approval/flexi-wo-approval.module')
      .then(m => m.FlexiWOApprovalModule),
    canActivate: [AuthService]
  },
  {
    path: 'associate-registration',
    loadChildren: () =>
      import('src/app/public/associate-registration/associate-registration.module').then(m => m.AssociateRegistrationModule)
  },
  {
    path: 'Loan-Approvals',
    loadChildren: () => import('src/app/core/ESS/loan-approval/loan-approval.component')
      .then(m => m.LoanApprovalModule),
    canActivate: [AuthService]
  },
  {
    path: 'Travel-Approvals',
    loadChildren: () => import('src/app/core/ESS/travel-approvals/travel-approvals.component')
      .then(m => m.TravelApprovalsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Attendance-Approvals',
    loadChildren: () => import('src/app/core/ESS/attendance-approvals/attendance-approvals.component')
      .then(m => m.AttendanceApprovalsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Miss-Punch-Approvals',
    loadChildren: () => import('src/app/core/ESS/miss-attendance-approval/miss-attendance-approval.component')
      .then(m => m.MissAttendanceApprovalModule),
    canActivate: [AuthService]
  },
  {
    path: 'Gate-Pass-Approvals',
    loadChildren: () => import('src/app/core/ESS/miss-attendance-approval/miss-attendance-approval.component')
      .then(m => m.MissAttendanceApprovalModule),
    canActivate: [AuthService]
  },
  {
    path: 'CompOff-Approvals',
    loadChildren: () => import('src/app/core/ESS/compoff-approvals/compoff-approvals.component')
      .then(m => m.CompoffApprovalModule),
    canActivate: [AuthService]
  }, {
    path: 'Timesheet-Approvals',
    loadChildren: () => import('src/app/core/ESS/esstimesheet-approval/esstimesheet-approval.component')
      .then(m => m.TimesheetApprovalModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'Assets-Details',
  //   loadChildren: () => import('src/app/core/component/assets-details/assets-details/assets-details.module')
  //     .then(m => m.AssetsDetailsModule),
  //   canActivate: [AuthService]
  // }, 

  // {
  //   path: 'PF-Trust',
  //   loadChildren: () => import('src/app/core/component/pf-trust/pf-trust.module')
  //     .then(m => m.PfTrustModule),
  //   canActivate: [AuthService]
  // }, 
  {
    path: 'My-Details/:pageType',
    loadChildren: () => import('src/app/core/ESS/my-details/my-details.component')
      .then(m => m.MyDetailsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Assets',
    loadChildren: () => import('src/app/core/ESS/asset-details/asset-details.component')
      .then(m => m.AssetDetailsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Financials',
    loadChildren: () => import('src/app/core/ESS/financials/financials.component')
      .then(m => m.FinancialsModule),
    canActivate: [AuthService]
  },
  {
    path: 'HR-Activities',
    loadChildren: () => import('src/app/core/ESS/hr-activities/hr-activities.component')
      .then(m => m.HrActivitiesModule),
    canActivate: [AuthService]
  },
  {
    path: 'Team-Members',
    loadChildren: () => import('src/app/core/component/team-members/team-members/team-members.module')
      .then(m => m.TeamMembersModule),
    canActivate: [AuthService]
  },
  //  {
  //   path: 'Miss-Punch',
  //   loadChildren: () => import('src/app/core/component/miss-punch/miss-punch.component')
  //     .then(m => m.MissPunchModule),
  //   canActivate: [AuthService]
  // }, 
  {
    path: 'Social',
    loadChildren: () => import('src/app/core/component/social/social.module')
      .then(m => m.SocialModule),
    canActivate: [AuthService]
  }, {
    path: 'Offers',
    loadChildren: () => import('src/app/core/component/offers/offers.component')
      .then(m => m.OffersModule),
    canActivate: [AuthService]
  },
  {
    path: 'Employee-Directory',
    loadChildren: () => import('src/app/core/ESS/employee-directory-dashboard/employee-directory-dashboard.component')
      .then(m => m.EmployeeDirectoryDashboardModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'Org-Chart',
  //   component: OrgChartComponent,
  //   canActivate: [AuthService]
  // },
  {
    path: 'Team-Attendance-Summary',
    loadChildren: () => import('src/app/core/component/team-members-summary/team-members-summary/team-members-summary.module')
      .then(m => m.TeamMembersSummaryModule),
    canActivate: [AuthService]
  },
  //  {
  //   path: 'Holiday-Work',
  //   loadChildren: () => import('src/app/core/component/leave-grant/leave-grant.module')
  //     .then(m => m.LeaveGrantModule),
  //   canActivate: [AuthService]
  // },
  //  {
  //   path: 'Team-Members-Attendance',
  //   loadChildren: () => import('src/app/core/component/team-members-attendance/team-members-attendance/team-members-attendance.module')
  //     .then(m => m.TeamMembersAttendanceModule),
  //   canActivate: [AuthService]
  // },

  {
    path: 'Insurance-Details',
    loadChildren: () => import('src/app/core/component/insurance-details/insurance-details.module')
      .then(m => m.InsuranceDetailsModule),
    canActivate: [AuthService]
  },
  {
    path: 'home',
    loadChildren: () =>
      import('src/app/pages/home/home.component').then(m => m.HomeModule),
    canActivate: [AuthService]
  },
  //  {
  //   path: 'Timesheet-Submission',
  //   loadChildren: () =>
  //     import('src/app/core/component/esstimesheet-submission/esstimesheet-submission.component').then(m => m.EssTimesheetSubmissionModule),
  //   canActivate: [AuthService]
  // },
  // {
  //   path: 'Timesheet-Submission',
  //   loadChildren: () =>
  //     import('src/app/core/component/esstimesheet-submission1/esstimesheet-submission.component').then(m => m.EssTimesheetSubmissionModule),
  //   canActivate: [AuthService]
  // },
  // {
  //   path: 'LeaveApprove',
  //   loadChildren: () =>
  //     import('src/app/public/public-leave-apply/public-leave-apply.component').then(m => m.PublicLeaveApplyModule)
  // },
  {
    path: 'LeaveApprove',
    loadChildren: () =>
      import('src/app/public/public-leave-apply01/public-leave-apply.component').then(m => m.PublicLeaveApplyModule)
  },
  {
    path: 'FaceRecognitionApprove',
    loadChildren: () =>
      import('src/app/public/public-face-recognition-approvals/public-face-recognition-approvals.module').then(m => m.PublicFaceRecognitionApprovalsModule)
  },
  {
    path: 'FlexiApprove',
    loadChildren: () =>
      import('src/app/public/public-flexi-wo-approval/public-flexi-wo-approval.module').then(m => m.PublicFlexiWoApprovalModule)
  },
  {
    path: 'EmployeeInfo',
    loadChildren: () =>
      import('src/app/public/public-consultant-info/public-consultant-info.component').then(m => m.PublicConsInfoModule)
  },
  {
    path: 'LoanApprove',
    loadChildren: () =>
      import('src/app/public/public-loan-apply/public-loan-apply.component').then(m => m.PublicLoanApplyModule)
  },
  {
    path: 'CompOffApproval',
    loadChildren: () =>
      import('src/app/public/public-comp-off-approval/public-comp-off-approval.component').then(m => m.PublicCompOffApprovalModule)
  },
  {
    path: 'ResignApproval',
    loadChildren: () =>
      import('src/app/public/public-resign-approval/public-resign-approval.component').then(m => m.PublicResignApprovalModule)
  },
  {
    path: 'ObApproval',
    loadChildren: () =>
      import('src/app/public/public-onboard-initiate-approval/public-onboard-initiate-approval.component').then(m => m.PublicOnboardInitiateApprovalModule)
  },
  {
    path: 'OfferApproval',
    loadChildren: () =>
      import('src/app/public/public-offer-approval/public-offer-approval.component').then(m => m.PublicOfferApprovalModule)
  },
  {
    path: 'ReferAFriend',
    loadChildren: () =>
      import('src/app/public/public-refer-a-friend/public-refer-a-friend.component').then(m => m.PublicReferAFriendModule)
  },
  {
    path: 'MissPunchApproval',
    loadChildren: () =>
      import('src/app/public/public-attend-correction-approval/public-attend-correction-approval.component').then(m => m.PublicAttendCorrectionApprovalModule)
  },
  {
    path: 'GatePassApproval',
    loadChildren: () =>
      import('src/app/public/public-attend-correction-approval/public-attend-correction-approval.component').then(m => m.PublicAttendCorrectionApprovalModule)
  },

  //  {
  //   path: 'jobs',
  //   loadChildren: () =>
  //     import('src/app/public/public-current-openings/public-current-openings.component').then(m => m.PublicCurrentJobModule)
  // },
  {
    path: 'jobs',
    loadChildren: () =>
      import('src/app/public/public-current-openings1/public-current-openings.component').then(m => m.PublicCurrentJobModule)
  },
  //  {
  //   path: 'job-details',
  //   loadChildren: () =>
  //     import('src/app/public/public-job-details/public-job-details.component').then(m => m.PublicCurrentJobDetailsModule)
  // },
  {
    path: 'job-details',
    loadChildren: () =>
      import('src/app/public/public-job-details1/public-job-details.component').then(m => m.PublicCurrentJobDetailsModule)
  },
  {
    path: 'assessment',
    loadChildren: () =>
      import('src/app/public/public-assessment/public-assessment.module').then(m => m.PublicAssessmentModule)
  },
  {
    path: 'self-onboarding',
    loadChildren: () =>
      import('src/app/public/public-common-onboarding/public-common-onboarding.module').then(m => m.PublicCommonOnboardingModule)
  },
  {
    path: 'early-attendance',
    loadChildren: () =>
      import('src/app/public/public-early-attendance/public-early-attendance.component').then(m => m.PublicEarlyAttendanceModule)
  },
  {
    path: 'apply-for-job',
    loadChildren: () =>
      import('src/app/public/public-apply-for-job/public-apply-for-job.component').then(m => m.PublicApplyJobModule)
  }, {
    path: 'token',
    loadChildren: () =>
      import('src/app/public/public-cvtoken-mail/public-cvtoken-mail.component').then(m => m.PublicCVTokenMailModule)
  }, {
    path: 'Resume-List',
    loadChildren: () =>
      import('src/app/public/public-cvtoken-mail-details/public-cvtoken-mail-details.component').then(m => m.PublicCVListModule)
  }, {
    path: 'Interview-Feedback',
    loadChildren: () =>
      import('src/app/public/public-interview-feedback/public-interview-feedback.component').then(m => m.PublicInterviewFeedbackModule)
  }, {
    path: 'Timesheet-Approval',
    loadChildren: () =>
      import('src/app/public/public-timesheet-approval-token/public-timesheet-approval-token.component').then(m => m.PublicTSAModule)
  }, {
    path: 'Pay-Register',
    loadChildren: () =>
      import('src/app/public/public-pay-register-to-client-token/public-pay-register-to-client-token.component').then(m => m.PublicPayRegisterModule)
  },
  {
    path: 'folder-doc',
    loadChildren: () =>
      import('src/app/public/public-doc-folder/public-doc-folder.module').then(m => m.PublicDocFolderModule)
  },
  // {
  //   path: 'TSApprove',
  //   loadChildren: () =>
  //     import('src/app/public/public-timesheet-approve/public-timesheet-approve.component').then(m => m.PublicTSAModule)
  // },
  {
    path: 'TSApprove',
    loadChildren: () =>
      import('src/app/public/public-timesheet-approve01/public-timesheet-approve.component').then(m => m.PublicTSAModule)
  },
  // {
  //   path: 'RimApprove',
  //   loadChildren: () =>
  //     import('src/app/public/public-reimbursement-claim-apply/public-reimbursement-claim-apply.component').then(m => m.PublicRembursementModule)
  // },
  {
    path: 'RimApprove',
    loadChildren: () =>
      import('src/app/public/public-reimbursement-claim-apply01/public-reimbursement-claim-apply.component').then(m => m.PublicRembursementModule)
  },
  {
    path: 'Invoice',
    loadChildren: () =>
      import('src/app/public/public-invoice/public-invoice.component').then(m => m.PublicInvoiceModule)
  },
  {
    path: 'ESS-Home',
    loadChildren: () =>
      import('src/app/pages/ess-home/ess-home.component').then(m => m.ESSHomeModule),
    canActivate: [AuthService]
  },
  {
    path: 'Requirements',
    loadChildren: () =>
      import('src/app/core/component/requirements/requirements.module').then(m => m.RequirementsModule),
    canActivate: [AuthService]
  },
  {
    path: 'FAQ-Template',
    loadChildren: () =>
      import('src/app/core/component/faq-template/faq-template.component').then(m => m.FaqTemplateModule),
    canActivate: [AuthService]
  },
  {
    path: 'nodatafound',
    component: NodatafoundComponent,
    canActivate: [AuthService]
  },
  {
    path: 'consultant-documentation',
    loadChildren: () =>
      import('src/app/core/component/consultent-documentatio/consultent-documentation/consultent-documentation.module').then(m =>
        m.ConsultentDocumentationModule),
    canActivate: [AuthService]
  },
  {
    path: 'Personal-Info',
    loadChildren: () =>
      import('src/app/core/component/new-personal-info/new-personal-info/new-personal-info.module').then(m => m.NewPersonalInfoModule),
    canActivate: [AuthService]
  },
  {
    path: 'Address-Info',
    loadChildren: () =>
      import('src/app/core/component/address-info/address-info-module/address-info.module').then(m => m.AddressInfoModule),
    canActivate: [AuthService],
  },
  {
    path: 'Onboarding-Declaration',
    loadChildren: () =>
      import('src/app/core/component/ess-onboarding-declaration/ess-onboarding-declaration.component').then(m => m.EssOnboardingDeclarationModule),
    canActivate: [AuthService],
  },
  // {
  //   path: 'General-Declaration',
  //   loadChildren: () =>
  //     import('src/app/core/component/general-declarations/general-declarations.component').then(m => m.GeneralDeclarationsModule),
  //   canActivate: [AuthService],
  // },
  {
    path: 'Family-info',
    loadChildren: () => import('src/app/core/component/family-info/family-info/family-info.module').then(m => m.FamilyInfoModule),
    canActivate: [AuthService]
  },
  {
    path: 'Education-info',
    loadChildren: () => import('src/app/core/component/education-info/education-info/education-info.module').then(m =>
      m.EducationInfoModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'Bill-Authorization',
  //   loadChildren: () => import('src/app/core/component/bill-authorization/bill-authorization.component').then(m =>
  //     m.BillAuthorizationModule),
  //   canActivate: [AuthService]
  // },
  {
    path: 'Employement-info',
    loadChildren: () => import('src/app/core/component/employee-info/employee-info/employee-info.module')
      .then(m => m.EmployeeInfoModule),
    canActivate: [AuthService]
  },
  {
    path: 'Bank-Details',
    loadChildren: () => import('src/app/core/WP/wp-bank-details/wp-bank-details.component').then(m =>
      m.WPBankInfoModule),
    canActivate: [AuthService]
  },
  {
    path: 'Statutory-Details',
    loadChildren: () => import('src/app/core/WP/statutory-details/statutory-details.component').then(m =>
      m.StatutoryModule),
    canActivate: [AuthService]
  },
  {
    path: 'Offer-Acceptance',
    loadChildren: () => import('src/app/core/Master/offer-acceptance/offer-acceptance.component').then(m => m.OfferAcceptanceModule),
    canActivate: [AuthService]
  },
  {
    path: 'login',
    loadChildren: () => import('src/app/shared/components/login-form/login-form.component').then(m => m.LoginFormModule),
    canActivate: [AuthService]
  },
  {
    path: 'ssologin',
    loadChildren: () => import('src/app/shared/components/sso-login/sso-login.module').then(m => m.SsoLoginModule),
    // canActivate: [AuthService]
  },
  {
    path: 'register',
    loadChildren: () => import('src/app/shared/components/register-form/register-form.component').then(m => m.RegisterFormModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'personalinfo',
  //   loadChildren: () => import('src/app/core/component/personal-details/personal-details.module').then(m => m.PersonalDetailsModule),
  //   canActivate: [AuthService]
  // },
  // {
  //   path: 'skill-details',
  //   loadChildren: () => import('src/app/core/component/skill-details/skill-details/skill-details.module').then(m => m.SkillDetailsModule),
  //   canActivate: [AuthService]
  // },
  {
    path: 'Salary-details',
    loadChildren: () => import('src/app/core/component/ess-salary-details/ess-salary-details/ess-salary-details.module')
      .then(m => m.EssSalaryDetailsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Approved-Timesheet',
    loadChildren: () => import('src/app/core/component/approved-timesheet/approved-timesheet-module/approved-timesheet.module')
      .then(m => m.ApprovedTimesheetModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'Pay-Details',
  //   loadChildren: () => import('src/app/core/component/ess-payroll-details/ess-payroll-details-Module/ess-payroll-details.module')
  //     .then(m => m.EssPayrollDetailsModule),
  //   canActivate: [AuthService]
  // },
  // {
  //   path: 'Reimbursement-Claim',
  //   loadChildren: () => import('src/app/core/component/ess-reimbursement-claim/reimbursement-claim/reimbursement-claim.module')
  //     .then(m => m.ReimbursementClaimModule),
  //   canActivate: [AuthService]
  // },
  // {
  //   path: 'Apply-Leave',
  //   loadChildren: () => import('src/app/core/component/ess-leave-apply/leave-apply/leave-apply.module')
  //     .then(m => m.LeaveApplyModule),
  //   canActivate: [AuthService]
  // },
  // {
  // {
  //   path: 'Attendance-Correction',
  //   loadChildren: () => import('src/app/core/component/attend-punchlog/attend-punchlog/attend-punchlog.module')
  //     .then(m => m.AttendPunchlogModule),
  //   canActivate: [AuthService]
  // },

  {
    path: 'Flexi-Weekoff',
    loadChildren: () => import('src/app/shared/components/flexi-wo-requests/flexi-wo-requests.module')
      .then(m => m.FlexiWoRequestsModule),
    canActivate: [AuthService]
  },
  {
    path: 'Change-Password',
    loadChildren: () => import('src/app/shared/components/reset-password/reset-password.component')
      .then(m => m.ResetPasswordModule),
    canActivate: [AuthService]
  },
  {
    path: 'Help',
    loadChildren: () => import('src/app/core/component/help-docs/help-docs.module')
      .then(m => m.HelpDocsModule),
    canActivate: [AuthService]
  },
  {
    path: 'My-Queries',
    loadChildren: () => import('src/app/core/ESS/essqueries/essqueries.component')
      .then(m => m.ESSQuerieModule),
    canActivate: [AuthService]
  },
  {
    path: 'References',
    loadChildren: () => import('src/app/core/component/ess-references/ess-references.component')
      .then(m => m.EssReferencesModule),
    canActivate: [AuthService]
  },
  {
    path: 'Inventory',
    loadChildren: () => import('src/app/core/component/inventory/inventory.component')
      .then(m => m.InventoryModule),
    canActivate: [AuthService]
  }, {
    path: 'PMS-Details',
    loadChildren: () => import('src/app/core/component/pms-template-list/pms-template-list.component')
      .then(m => m.PMSTemplateListModule),
    canActivate: [AuthService]
  },
  // {
  //   path: 'Investment-Declaration',
  //   loadChildren: () => import('src/app/core/Master/investment-declaration/investment-declaration.component')
  //     .then(m => m.InvestmentDeclarationModule),
  //   canActivate: [AuthService]
  // },
  {
    path: 'clients', component: ClientListComponent, canActivate: [AuthService]
  },
  {
    path: 'Attendance-Tracker',
    loadChildren: () => import('src/app/core/component/consultant-attendance-tracker/consultant-attendance-tracker.module')
      .then(m => m.ConsultantAttendanceTrackerModule),
    canActivate: [AuthService]
  },
  {
    path: 'sign-in',
    loadChildren: () => import('src/app/core/component/sign-in/sign-in.module')
      .then(m => m.SignInModule),
    canActivate: [AuthService]
  },
  {
    path: 'sign-in',
    loadChildren: () => import('src/app/core/component/sign-in/sign-in.module')
      .then(m => m.SignInModule),
    canActivate: [AuthService]
  },
  {
    path: 'Public',
    loadChildren: () => import('../../projects/public/src/app/public.module').then(m => m.PublicAppModule),
  },
  { path: 'access-denied', component: AccessDeniedComponent },
  {
    path: '**',
    component: NotfoundComponent,
    canActivate: [AuthService]
  },

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, { useHash: true }),
    DxDataGridModule,
    DxFormModule
  ],
  providers: [AuthService],
  exports: [RouterModule],
  declarations: [ProfileComponent, DisplayDataComponent]
})
export class AppRoutingModule { }
